import { Typography } from "antd";
import { Link } from "react-router-dom";

export const DOC_LINKS = {
  appServiceAuth:
    "https://learn.microsoft.com/en-us/azure/app-service/overview-authentication-authorization",
  functionAppSettings:
    "https://learn.microsoft.com/en-us/azure/azure-functions/functions-app-settings",
  premiumPlans:
    "https://learn.microsoft.com/en-us/azure/azure-functions/functions-premium-plan",
  hostingPlans:
    "https://learn.microsoft.com/en-us/azure/app-service/overview-hosting-plans",
  createFunctionApp:
    "https://learn.microsoft.com/en-us/azure/azure-functions/functions-create-function-app-portal?tabs=core-tools&pivots=premium-plan",
  permissionsConsent:
    "https://learn.microsoft.com/en-us/entra/identity-platform/permissions-consent-overview#types-of-permissions",
  appRegistrations:
    "https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade",
  resourceGroups: "https://portal.azure.com/#create/Microsoft.ResourceGroup",
  storageAccounts: "https://portal.azure.com/#create/Microsoft.StorageAccount",
  appServicePlans: "https://portal.azure.com/#create/Microsoft.AppServicePlan",
  functionApps: "https://portal.azure.com/#create/Microsoft.FunctionApp",
};

export const DocLink: React.FC<{ url: string; text: string }> = ({
  url,
  text,
}) => (
  <Link to={url} target="_blank" rel="noreferrer">
    {text}
  </Link>
);

export const FunctionAppNavigationText: React.FC<{
  additionalPath?: React.ReactNode;
}> = ({ additionalPath }) => (
  <Typography.Paragraph>
    Navigate to your Function App → <code>Settings</code>
    {additionalPath ? <>→ {additionalPath}</> : ""}
  </Typography.Paragraph>
);

export const FunctionAppSettingsInstructions: React.FC = () => (
  <Typography.Paragraph>
    {FunctionAppNavigationText({
      additionalPath: <code>Configuration</code>,
    })}
    . See{" "}
    {DocLink({
      url: DOC_LINKS.functionAppSettings,
      text: "function app settings documentation",
    })}{" "}
    for more details. Add these application settings:
  </Typography.Paragraph>
);

export const AppServiceAuthenticationLink: React.FC = () =>
  DocLink({
    url: DOC_LINKS.appServiceAuth,
    text: "App Service Authentication",
  });
